import React from 'react';
import HandshakeOutlinedIcon from '@mui/icons-material/HandshakeOutlined';
import PersonAddAlt1OutlinedIcon from '@mui/icons-material/PersonAddAlt1Outlined';
import ThumbUpAltOutlinedIcon from '@mui/icons-material/ThumbUpAltOutlined';
import SwitchAccessShortcutAddOutlinedIcon from '@mui/icons-material/SwitchAccessShortcutAddOutlined';

const ourValuesData = {
  title: 'Nuestros valores',
  description: 'Nuestro equipo está compuesto por mentes creativas y brillantes de distintas generaciones y culturas, '
  + 'amantes de la innovación y la tecnología, lo cual genera un ambiente lleno de aprendizaje y oportunidades para que te desarrolles tanto en lo personal como en lo profesional. '
  + 'Te invitamos a postular para ser parte de nuestro tremendo equipo.',
  values: [
    {
      id: 0,
      title: 'Colaboramos',
      description: 'Fomentamos la confianza, el respeto y el trabajo en equipo para alcanzar nuestros objetivos de manera conjunta.',
      icon: <HandshakeOutlinedIcon sx={{ color: 'white' }} />,
    },
    {
      id: 1,
      title: 'Nos orientamos hacia el cliente',
      description: 'Nuestros clientes son el centro de todo lo que hacemos. Entendemos sus necesidades y generamos impacto positivo.',
      icon: <PersonAddAlt1OutlinedIcon sx={{ color: 'white' }} />,
    },
    {
      id: 2,
      title: 'Nos hacemos cargo',
      description: 'Asumimos la responsabilidad de nuestras acciones, cumpliendo compromisos y enfrentando desafíos con determinación.',
      icon: <ThumbUpAltOutlinedIcon sx={{ color: 'white' }} />,
    },
    {
      id: 3,
      title: 'Nos adaptamos e innovamos',
      description: 'Estamos en constante evolución, aprendiendo y aplicando nuevas ideas para innovar en nuestras soluciones.',
      icon: <SwitchAccessShortcutAddOutlinedIcon sx={{ color: 'white' }} />,
    },
  ],
};

export default ourValuesData;
